import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { EntityType, EntityKey, EntitiesMap } from "../../entities";

interface EntityNamespace {
  entities: EntitiesMap;
}

interface EntityResult {
  [key: string]: EntityType | EntityType[];
}

type EntitySelector<T> = { [key in keyof T]: EntityId | EntityId[] | undefined };

interface OwnProps<T> {
  selector: EntitySelector<T>;
  children: (entities: Partial<T>) => React.ReactNode;
}
type Props<T> = {
  entities: Partial<T>;
  selector: EntitySelector<T>;
} & OwnProps<T>;

export default function withEntitiesFactory<T extends EntityResult>(
  mapper: { [key in keyof T]: EntityKey },
  namespace: keyof RootState | undefined
): React.ComponentType<OwnProps<T>> {
  class WithEntities extends React.Component<Props<T>> {
    public render() {
      const { children, entities } = this.props;
      return children(entities);
    }
  }

  function mapStateToProps(state: RootState, { selector }: OwnProps<T>) {
    let entities = state.entities;
    if (namespace) {
      if ((state[namespace] as EntityNamespace).entities) {
        entities = (state[namespace] as EntityNamespace).entities;
      } else {
        throw new Error(`Namespace(${namespace}) has no entities`);
      }
    }
    const res: Partial<T> = {};
    Object.entries(selector).forEach(([key, id]) => {
      const entityKey = mapper[key] as EntityKey;
      if (Array.isArray(id)) {
        // TODO(Kento): Fix any
        res[key] = id.map(i => (entities[entityKey] || {})[i]) as any;
      } else if (typeof id === "string") {
        res[key] = (entities[entityKey] || {})[id];
      } else {
        res[key] = undefined;
      }
    });
    return {
      entities: res,
    };
  }

  return connect(mapStateToProps)(WithEntities);
}



// WEBPACK FOOTER //
// ./frontend/src/common/utils/withEntitiesFactory.ts